import styles from './index.scss'
import { useEffect, useState } from 'react'
import { useModel } from 'umi'
import { Empty } from 'antd-mobile'
import { usableEquityList } from '@/services'
import Layout from '@/libs/components/Layout'
import iconSelected from '@/assets/image/xuanzhong.png'
import iconUnSelected from '@/assets/image/buxuanzhong.png'
import goTo from '@/libs/functions/goTo'
import EquityCard from '@/libs/components/EquityCard'
import EquityActivateCard from '@/libs/components/EquityActivateCard'
import { getUrlAllParams, getUrlParam } from '@/libs/functions/getValue'
import { setStorage } from '@/libs/functions/onStorage'
import { SvgRadioSuccessIcon } from '@/libs/components/Icon/svgIcon'
import useCategorySet from '@/libs/hooks/useCategorySet'
import { hex2Rgb } from '@/libs/functions/tools'

import { equityActivate } from '@/services'

import emptyIcon from '@/assets/image/ico_empty.png'

export default function UsableEquity() {
  const serviceTime = getUrlParam('serviceTime') || ''
  const { proCode, proNum, categoryType, skuCode } = getUrlAllParams() as any
  const { setQiankunGlobalState, qiankunGlobalState } = useModel(
    '@@qiankunStateForSlave',
  )
  const { equity } = qiankunGlobalState
  const [listData, setListData] = useState<any>([])
  const [activateListData, setActivateListData] = useState<any>([])
  const { categorySetting } = useCategorySet(categoryType)

  const getData = () => {
    usableEquityList({
      proCode,
      proNum,
      categoryType,
      skuCode,
      serviceTime,
    }).then((res: any) => {
      setListData(res?.enableList)
      setActivateListData(res?.disableList)
    })
  }

  useEffect(() => {
    getData()
  }, [])
  const onSelect = (equity: any) => {
    // 卡券(SC/SSC)/实物(SW)：标记用户已手动选择权益(含“不使用权益券”)，
    // 避免返回确认订单页时自动回显覆盖用户选择；其它品类不写标记、不受影响
    if (proCode && ['SC', 'SSC', 'SW'].includes(categoryType)) {
      setStorage('asset:manual', { proCode }, { storageType: 'session' })
    }
    setQiankunGlobalState({
      equity,
    })
    // 卡券/实物：选权益后清空优惠券（互斥）。权益标识字段为 equityCouponCode
    if (
      ['SC', 'SSC', 'SW'].includes(categoryType) &&
      equity.equityCouponCode
    ) {
      setQiankunGlobalState({
        discount: {},
      })
    }
    goTo(-1)
  }

  const goToDetail = (equityCouponUrl: string) => {
    setQiankunGlobalState({
      equity: {},
    })
    goTo(equityCouponUrl)
  }

  return (
    <Layout title={'我的权益券'}>
      <div
        className={styles.usableCouponPage}
        style={{
          '--certify-primary-color':
            categorySetting?.certificatePage?.primaryColor,
          '--certify-secondary-color':
            categorySetting?.certificatePage?.secondaryColor,
          '--certify-secondary-color-rgb': hex2Rgb(
            categorySetting?.certificatePage?.secondaryColor,
          ),
        }}
      >
        <div className={styles.list}>
          <div className={styles.notUse} onClick={() => onSelect({})}>
            <div className={styles.text}>不使用权益券</div>
            {equity.equityCouponCode ? (
              <img src={iconUnSelected} className={styles.icon} />
            ) : (
              <SvgRadioSuccessIcon
                width={20}
                height={20}
                color={
                  categorySetting?.certificatePage?.primaryColor ||
                  'var(--certify-primary-color)'
                }
              />
            )}
          </div>
          {listData.length > 0 &&
            listData.map((v: any) => (
              <EquityCard
                key={v.equityCouponCode}
                name={v.equityName}
                date={
                  v.equityExpirationEnd
                    ? '有效期至' + v.equityExpirationEnd.slice(0, 10)
                    : ''
                }
                categoryType={categoryType}
                color={
                  categorySetting?.certificatePage?.primaryColor ||
                  'var(--certify-primary-color)'
                }
                onSelect={() => onSelect(v)}
                check={equity.equityCouponCode === v.equityCouponCode}
                count={v.availableEquityNumName || v.availableEquityNum}
                handleType="check"
                unit={v.equityUnitName}
              />
            ))}
          {!!activateListData?.length && (
            <div className={styles['activate-title']}>
              以下权益不可用{' '}
              <span className={styles['num']}>
                {activateListData?.length}张
              </span>
            </div>
          )}
          {!!activateListData?.length &&
            activateListData.map((ali: Record<string, any>) => (
              <EquityActivateCard
                key={ali.equityCouponCode}
                name={ali.equityName}
                date={ali.equityExpirationEndText}
                categoryType={categoryType}
                onSelect={() => onSelect(ali)}
                check={equity.equityCouponCode === ali.equityCouponCode}
                count={ali.availableEquityNumName || ali.availableEquityNum}
                handleType="check"
                unit={ali.equityUnitName}
                equityExpirationEndText={ali.equityExpirationEndText}
                equityStatus={ali.equityStatus}
                disableDesc={ali.disableDesc}
                activeParams={{ equityCouponCode: ali.equityCouponCode }}
                onReload={getData}
                activeFunc={equityActivate}
                goToDetail={() => goToDetail(ali.equityCouponUrl)}
              />
            ))}
          {listData.length === 0 && activateListData.length === 0 && (
            <div
              style={{
                textAlign: 'center',
                marginTop: '50px',
                color: '#9B9B9B',
              }}
            >
              <Empty
                image={emptyIcon}
                imageStyle={{ height: 118, width: 157 }}
                style={{ padding: 0 }}
              />
              暂无可用权益券
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}
